// src/redux/slices/cabinetsSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Source from "../../Source";

// Async thunks
export const fetchCabinets = createAsyncThunk("cabinets/fetchCabinets", async (_, thunkAPI) => {
  try {
    const response = await axios.get(Source.getAddress() + "/api/cabin", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access")}`,
      },
    });
    // console.log(response);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue("Failed to fetch cabinets");
  }
});

export const addCabinet = createAsyncThunk("cabinets/addCabinet", async (formData, thunkAPI) => {
  try {
    const response = await axios.post(Source.getAddress() + "/api/cabin", formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access")}`,
      },
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue("Failed to add cabinet");
  }
});

export const updateCabinet = createAsyncThunk("cabinets/updateCabinet", async ({ id, data }, thunkAPI) => {
  try {
    await axios.put(Source.getAddress() + `/api/cabin/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access")}`,
      },
    });
    return { id, data };
  } catch (error) {
    return thunkAPI.rejectWithValue("Failed to update cabinet");
  }
});

export const deleteCabinet = createAsyncThunk("cabinets/deleteCabinet", async (id, thunkAPI) => {
  try {
    await axios.delete(Source.getAddress() + `/api/cabinet/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access")}`,
      },
    });
    return id;
  } catch (error) {
    return thunkAPI.rejectWithValue("Failed to delete cabinet");
  }
});

// Slice
const cabinetsSlice = createSlice({
  name: "cabinets",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchCabinets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCabinets.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCabinets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // add
      .addCase(addCabinet.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      // update
      .addCase(updateCabinet.fulfilled, (state, action) => {
        const index = state.list.findIndex(c => c.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = { ...state.list[index], ...action.payload.data };
        }
      })
      // delete
      .addCase(deleteCabinet.fulfilled, (state, action) => {
        state.list = state.list.filter(c => c.id !== action.payload);
      });
  },
});

export default cabinetsSlice.reducer;
